import { uniqueId } from "@tm/utils"
import { Advertisement } from "@tm/models"
import { GetAdvertisementResponse } from "./model"

function mapAdvertisement(data: any): Advertisement | undefined {
    if (!data) {
        return
    }
    return {
        ...data,
        itemId: uniqueId(),
        validFrom: data.validFrom ? new Date(data.validFrom) : undefined,
        validTo: data.validTo ? new Date(data.validTo) : undefined,
    }
}

export function mapGetAdvertisementResponse(data: any): GetAdvertisementResponse | undefined {
    if (!data) {
        return
    }
    return {
        ...data,
        advertisements: data.advertisements && data.advertisements.map(mapAdvertisement),
    }
}
